const test = null; // 'preproduction'; // 'production'; //
const environment = test ? test : ENVIRONMENT;
const config = require(`../../config/config.${environment}.json`);

export function getApiUrl() {
  return config.api;
}

export function getCdnUrl() {
  return config.cdn;
}

export function getEnv() {
  return config.env;
}

export function getProtocol() {
  return config.protocol;
}

export function getAlgoliaAppName() {
  return config.algolia;
}

export function getWepayKey() {
  return config.wepay;
}

export function getReCaptchaKey() {
  return config.reCAPTCHA;
}

export function getAlgoliaDonationIndexName() {
  return 'fundky_donations_' + environment;
}

export function getPlatformAlias(url = "") {
  const protocol = getProtocol();
  const env = getEnv();
  return url.split('.fundkyapp.com')[0].replace(protocol, '').replace(env, '');
}

export function getPlatformUrl(alias = "") {
  const protocol = getProtocol();
  const env = getEnv();
  return `${protocol}${alias}${env}.fundkyapp.com`;
}

export function getFees(organization) {
  let fixed = config.fees.fixed;
	let percentage = config.fees.perc;

  if (organization.settings && organization.settings.fee && organization.settings.fee.percentage) percentage = organization.settings.fee.percentage;
  if (organization.settings && organization.settings.fee && organization.settings.fee.percentage) fixed = organization.settings.fee.fixed;
	
  let fees = {
		fixed: fixed,
		percentage: percentage
	}

  return fees;
}